import { URL } from "../constants";
import { mapStrategies, mapCompareStrategies } from './mappers';
import { transposeStrategies } from './utils';
import axios from "axios";

const getRequest = async url => {
  try {
    let response = await axios.get(url);
    if (response.status < 200 || response.status >= 300) {
      throw new Error(response.statusText);
    }
    return response.data;
  } catch (e) {
    return Promise.reject(e);
  }
};

const getCrops = () => {
  return getRequest(URL + `/OgrasTreatment/GetCategorys`);
};

const getSeasons = () => {
  return getRequest(URL + `/OgrasTreatment/GetSeasons`);
};

const getWeeds = async (cropId, seasonId) => {
  let url =
    URL +
    "/OgrasTreatment/GetOgras?SeasonID=" +
    seasonId +
    "&CategoryID=" +
    cropId;
  let weeds = await getRequest(url);
  let newWeeds = weeds.map(weed => {
    return {
      id: weed.value,
      name: weed.text
    };
  });
  return newWeeds;
};

const getCompareStrategies = async (cropId, seasonId, strategies,selectedWeeds) => {
  let url =
    URL +
    "/OgrasTreatment/CompareOgrasTreatment?SeasonID=" +
    seasonId +
    "&CategoryID=" +
    cropId +
    "&ListofOgrasTreatmentToCompare=" +
    strategies +
   (selectedWeeds ? `&ListofSelectedOgras=${selectedWeeds}` : '');

  let result = await getRequest(url);
  let transposed = transposeStrategies(result);
  let mappedTransposed = mapCompareStrategies(transposed);
  mappedTransposed.effects = Object.values(transposeStrategies(mappedTransposed.effectOnWeeds));
  return mappedTransposed;
};

const getStrategies = async (cropId, seasonId, weeds, groupId) => {
  if (typeof(groupId) == 'undefined') {
    groupId = 0;
  }
  let url =
    URL +
    "/OgrasTreatment/GetProductsAndTreatments?SeasonID=" + seasonId +
    "&CategoryID=" + cropId + " + &ListofSelectedOgras=" + (weeds ? weeds : '') +
    "&WeedTreatmentGroupID=" + groupId;;
  let serverStrategies = await getRequest(url);
  let strategies = mapStrategies(serverStrategies);
  return strategies;
};

const getTreatmentGroupNames = async (cropId, seasonId, weeds, groupId) => {
  let url =
    URL +
    "/OgrasTreatment/GetWeedTreatmentGroups?SeasonID=" + seasonId +
    "&CategoryID=" + cropId + " + &ListofSelectedOgras=" + weeds + "&ListofOgrasTreatmentToCompare" + groupId;

  return getRequest(url);
};

const filterStrategiesByTreatmentgroup = async (cropId, seasonId, weeds, groupId) => {
  let url =
    URL +
    "/OgrasTreatment/GetProductsAndTreatments?SeasonID=" + seasonId +
    "&CategoryID=" + cropId + " + &ListofSelectedOgras=" + weeds + "WeedTreatmentGroupID=" + groupId;

  return getRequest(url);
};

export { getCrops, getSeasons, getStrategies, getCompareStrategies, getTreatmentGroupNames, filterStrategiesByTreatmentgroup, getWeeds };

